export default "__VITE_ASSET__BjjDjzSq__"